import { Box } from '@mui/material'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

/**
 * The bot's face as the website draws it — uploaded image, or the robot glyph
 * when there isn't one.
 *
 * A URL that fails to load falls back to the glyph rather than leaving the
 * browser's broken-image icon sitting in the panel. The reset on `src` is what
 * makes a re-upload take: without it the first dead URL would latch this into
 * the broken state and every later image would be ignored.
 */
function AvatarPreview({ src, size, radius, iconSize }) {
  const [broken, setBroken] = useState(false)

  useEffect(() => setBroken(false), [src])

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: radius,
        overflow: 'hidden',
        flexShrink: 0,
        backgroundColor: '#F0AD5B',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {src && !broken ? (
        <Box
          component="img"
          src={src}
          alt=""
          onError={() => setBroken(true)}
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <SmartToyIcon sx={{ fontSize: iconSize }} />
      )}
    </Box>
  )
}

AvatarPreview.propTypes = {
  src: PropTypes.string,
  size: PropTypes.number.isRequired,
  radius: PropTypes.number.isRequired,
  iconSize: PropTypes.number.isRequired,
}

AvatarPreview.defaultProps = { src: '' }

export default AvatarPreview
